export default __webpack_public_path__ + "static/media/rm4.893f687a.png";